// extracted by mini-css-extract-plugin
export var button = "quantity-input-module--button--69608";
export var group = "quantity-input-module--group--5c671";
export var input = "quantity-input-module--input--640e3";